<template>
  <div class="pb-12">
    <div class="clearfix mt-24 mb-24 mlr" style="margin-bottom: 20px">
      <h3 class="text-bold-c111 font-s20 fl">
        {{ TLang("收货信息", "orderConfirm") }}
      </h3>
      <div
        class="fr text address-header"
        style="line-height: 30px"
        :class="{ disabled: addressList.length >= 25 }"
        @click="onNewAddress"
      >
        <span v-if="newAddressNotice" class="notice pl-8 pr-8">
          <img
            :src="require('@assets/images/order/notice-exclamation.png')"
            alt=""
          />
          <span> {{ TLang("请添加收货信息", "orderConfirm") }}</span>
        </span>
        <span class="iconfont mr-4 hover-rotate-360 font-s20">&#xe65a;</span>
        {{ TLang("新建收货地址", "orderConfirm") }}
      </div>
    </div>
    <div
      v-if="
      !showAddressTips&&
        epidemicDeliverInfo.allowDelivery === 0 &&
        epidemicDeliverInfo.promptWords
      "
      class="epidemicDeliverTip"
    >
      <div>{{ epidemicDeliverInfo.promptWords }}</div>
    </div>
    <div class="address-tips" v-if="showAddressTips">
      <div class="tips">
        <img :src="require('@assets/images/tips@2x.png')" />
        {{ TLang("checkAddressTips", "orderConfirm") }}
      </div>
      <div class="link" @click="showAddressListTips = true">
        {{ TLang("lookCity", "orderConfirm") }} <img :src="require('@assets/images/right@2x.png')" />
      </div>
    </div>

    <Dialog
      :title="TLang('您当前仅支持以下收货区域', 'orderConfirm')"
      :visible="showAddressListTips"
      width="420px"
      close-on-click-modal
      custom-class="freightDialog2"
      center
      top="30vh"
      :show-close="true"
      @open="invalideDialog = true"
      @close="showAddressListTips = false"
    >
      <div style="max-height: 260px; overflow-y: auto" class="address-tips-modal">
        <span v-for="(item, index) in checkAddress" :key="index">
          {{ item.provinceName + (item.cityName ? "-" + item.cityName : "") }}
        </span>
      </div>
      <div class="close-address" @click="showAddressListTips = false">
        知道了
      </div>
    </Dialog>
    <div
      ref="scrollTop"
      class="plr"
      :class="!moreAddressStatus ? 'shrink' : 'unwind overflow-y'"
    >
      <div
        v-for="(item, i) in addressList"
        :key="i"
        class="address-item clearfix"
      >
        <div class="fl clearfix">
          <div
            class="label-default fl line-clamp-1"
            :class="item.addressId === defaultAddressId && 'label-checked'"
            @click="onCheckedAddress(item)"
          >
            {{ TLang(item.tag || item.consignee, "address") }}
          </div>
          <div class="fl flex" style="line-height: 30px">
            <span class="font-c666 ml-24">{{ item.consignee }}</span>
            <span class="font-c666 ml-16 address-detail line-clamp-1">{{
              item.provinceName +
              item.cityName +
              item.regionName +
              item.streetName +
              item.address
            }}</span>
            <span class="text-num font-c666 ml-16">{{ item.mobile }}</span>
            <span v-if="item.defaultAddress === 1" class="defaultAddress">
              {{ TLang("默认", "address") }}
            </span>
          </div>
        </div>
        <div class="fr mr-24 clearfix">
          <div
            v-if="item.defaultAddress !== 1"
            class="fl opertion-item hover-item setdefault"
            @click="onSetDefautl(item)"
          >
            <span class="icon iconfont pdp_location vertical-middle geo"
              >&#xe64f;</span
            ><span>{{ TLang("设为默认", "address") }}</span>
          </div>
          <div class="fl opertion-item hover-item" @click="onEditAddress(item)">
            <span class="iconfont mr-4">&#xe647;</span
            ><span>{{ TLang("修改", "address") }}</span>
          </div>
          <div
            v-if="item.addressId !== defaultAddressId"
            id="item.addressId"
            class="fl opertion-item ml-24"
            @click="onShowConfirmDialog(item.addressId)"
          >
            <span class="iconfont mr-4">&#xe661;</span>
            {{ TLang("删除", "address") }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="addressList && addressList.length > 1"
      class="opertion-more-address text mt-4 ml-24"
      :class="!moreAddressStatus ? 'font-c666' : 'font-blue'"
      @click="onMoreAddress"
    >
      {{ TLang("更多地址", "address") }}
      <i
        class="el-input__icon el-icon-arrow-up rotate-180"
        :class="!moreAddressStatus ? '' : 'font-blue is-reverse'"
      ></i>
    </div>
    <confirm-dialog
      :img="require('@assets/images/delete.png')"
      :title="TLang('您要删除该收货地址吗', 'address')"
      :confirmBtnText="TLang('删除', 'address')"
      :cancelBtnText="TLang('再想想', 'address')"
      custom-class="delete-modal"
      @onCancelDialog="onCancelConfirmDialog"
      @onConfirmDialog="onDeleteAddress"
    ></confirm-dialog>
  </div>
</template>

<script>
import ConfirmDialog from "@components/confirmDialog";
import Cookies from "js-cookie";
import { mapState, mapActions } from "vuex";
import { Message, Dialog } from "element-ui";

export default {
  name: "OrderAddress",
  components: {
    // Popups,
    // PopupsEn,
    ConfirmDialog,
    Dialog,
  },
  props: {
    defaultAddressId: Number, // 默认收货地址
    addressList: Array,
    checkAddress: Array,
    editAddressItem: Object, // 需要完善收货地址
    loadding: Boolean,
    newAddressNotice: Boolean, // 提示新建地址
    invalideDialog: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    epidemicDeliverInfo: {
      type: Object,
      default: function () {
        return {
          allowDelivery: null,
          mandatoryType: null,
          promptWords: null,
        };
      },
    },
    onEdit: Function,
    onAdd: Function,
    onSetDefaultAddress: Function,
    sendGio: Function,
    settleAccountInfo: Object,
  },
  data() {
    return {
      confirmDialog: false, // 删除地址弹层状态
      confirmDialogData: {
        id: 0,
      }, // 删除地址
      editAddressDialog: false,
      addressDialog: {
        dialogState: true, // 编辑 false 添加 true
        title: this.TLang("新增收货地址", "orderConfirm"),
        enTitle: this.TLang("新增收货地址", "orderConfirm"),
        addressItem: null,
      }, // 地址新建、编辑弹层
      arrowReverse: "", // 箭头方向
      moreAddressStatus: false, // 初始状态 false
      showAddAddressNotice: false,
      showAddressTips: true,
      showAddressListTips: false,
    };
  },
  computed: {
    ...mapState("address", [
      "opertionsAddressId",
      "currentAddressItem",
      "deleteAddressState",
    ]),
  },
  watch: {
    // 增加、编辑改变状态
    currentAddressItem(nVal, oVal) {
      if (nVal !== oVal) {
        this.onCancelEditAddressDialog();
        this.onCheckedAddress(nVal);
      }
    },
    // 删除修改
    deleteAddressState(val) {
      if (val) {
        Message.success(this.TLang("修改地址成功", "address"));
      }
    },
    addressList(val) {
      console.log(val);
    },
    checkAddress: {
      handler(val) {
        if (val.length > 0) {
          this.showAddressTips = true;
        } else {
          this.showAddressTips = false;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // 短地址继续新建
    if (this.loadding && !this.editAddressItem.addressId) {
      this.editAddressDialog = !this.editAddressDialog;
      this.addressDialog.addressItem = this.editAddressItem;
    }
  },
  methods: {
    ...mapActions("address", [
      "addAddress",
      "editAddress",
    ]),
    onMoreAddress() {
      if (this.moreAddressStatus) {
        this.$refs.scrollTop.scroll({
          top: 0,
        });
      }
      this.moreAddressStatus = !this.moreAddressStatus;
      this.sendGio("收货信息", "更多地址");
    },
    onNewAddress() {
      this.onAdd();
      this.sendGio("收货信息", "新建收货地址");
    },
    onEditAddress(item) {
      this.onEdit(item);
      this.sendGio("收货信息", "修改");
    },
    onSetDefautl(item) {
      this.onSetDefaultAddress(item);
      this.sendGio("收货信息", "设为默认");
    },
    onCancelEditAddressDialog() {
      this.$parent.addressDialog.dialogState = true;
      this.$parent.addressDialog.title = this.TLang(
        "新建收货地址",
        "orderConfirm"
      );
      this.$parent.addressDialog.enTitle = this.TLang(
        "新建收货地址",
        "orderConfirm"
      );
      this.$parent.addressDialog.addressItem = {};
      this.$parent.editAddressDialog = false;
    },
    /**
     * 展示弹层并封装数据
     */
    onShowConfirmDialog(id) {
      this.confirmDialogData.id = id;
      this.confirmDialog = true;
    },
    onDeleteAddress() {
      const promise = this.$store.dispatch("address/deleteAddress", {
        userAddressId: this.confirmDialogData.id,
      });
      promise.then(() => {
        if (this.settleAccountInfo.orignOrderTotalFeight === 0 || this.settleAccountInfo.orignOrderTotalFeight > 0) {
          window.sessionStorage.setItem('oldTotalFreight', Number(this.settleAccountInfo.orignOrderTotalFeight))
        }
        setTimeout(() => {
          this.$parent.initData();
        }, 100);
        this.onCancelConfirmDialog();
      });
    },
    onCancelConfirmDialog() {
      this.confirmDialog = false;
      this.confirmDialogData.id = 0;
    },
    // 切换地址
    onCheckedAddress(item) {
      Cookies.set("address", item, { expires: 365 });
      console.log("Cookies.set6", item);
      if (this.settleAccountInfo.orignOrderTotalFeight === 0 || this.settleAccountInfo.orignOrderTotalFeight > 0) {
        window.sessionStorage.setItem('oldTotalFreight', Number(this.settleAccountInfo.orignOrderTotalFeight))
      }
      setTimeout(() => {
        this.$parent.initData();
      }, 100);
    },
  },
};
</script>

<style lang="less" scoped>
.address-tips {
  height: 16px;
  line-height: 16px;
  padding-left: 24px !important;
  margin-bottom:18px;
  display: flex;
  & > .tips {
    color: #e53838;
    font-size: 14px;
    font-weight: 400;
    & > img {
      width: 12px;
      height: 12px;
      vertical-align: baseline;
    }
  }
  & > .link {
    font-size: 14px;
    font-weight: 400;
    margin-left: 24px;
    color: #333333;
    cursor: pointer;
    & > img {
      width: 18px;
      height: 18px;
      vertical-align: sub;
    }
  }
}
span {
  display: inline-block;
}

::-webkit-scrollbar {
  display: block;
  margin-right: 16px;
  width: 4px;
  height: 80px;
  background: rgba(229, 229, 229, 1);
  border-radius: 2px;
}

.transition {
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
}

.rotate(@rotateDegree) {
  color: #666;
  font-size: 14px;
  -webkit-transform: rotateZ(@rotateDegree);
  transform: rotateZ(@rotateDegree);
  cursor: pointer;
  .transition;
}

.rotate-180 {
  .rotate(180deg);
}

.is-reverse {
  -webkit-transform: rotateZ(0);
  transform: rotateZ(0);
}

// 收缩
.shrink {
  height: 30px;
  overflow-y: hidden;
  transition: height 0.3s;
}

// 展开
.unwind {
  height: 224px;
  max-height: 224px;
  overflow-y: scroll;
  transition: height 0.3s;
}

// hover 360 度旋转
.hover-rotate-360 {
  .rotate(360deg);

  &:hover {
    .is-reverse;
  }
}

// 业务
.address-header {
  &:hover {
    color: #3d96e2;
    cursor: pointer;

    .iconfont {
      color: #3d96e2;
    }
  }
}
.disabled {
  color: #999;
  &:hover {
    color: #999;
    cursor: auto;
    .iconfont {
      color: #999;
      transition: none;
      cursor: default;
    }
  }
  .iconfont {
    color: #999;
    transition: none;
  }
}

.address-item {
  margin-top: 16px;

  &:first-of-type {
    margin-top: 0;
  }
  .address-detail {
    max-width: 500px;
    // line-height: 40px;
  }
  &:hover,
  &-checked {
    cursor: pointer;
    background-color: #f8fcff;
  }

  &:hover {
    .label-default {
      .label(110px, 26px, 2px, #3d96e2);
    }

    .opertion-item {
      color: #666;
    }
  }

  .opertion-item {
    line-height: 30px;
    color: #fff;
    vertical-align: middle;

    &:hover {
      cursor: pointer;
      color: @blue!important;
      .icon-font {
        color: @blue!important;
      }
    }
  }
  .setdefault {
    margin-right: 20px;
  }
  .defaultAddress {
    background: rgba(255, 246, 230, 1);
    border-radius: 9px;
    font-size: 11px;

    font-weight: 500;
    color: rgba(255, 175, 0, 1);
    line-height: 16px;
    padding: 2px 5px;
    margin-left: 12px;
  }
}

.opertion-more-address {
  cursor: pointer;
}
</style>
<style lang="less">
.close-address {
  margin-top: 30px !important;
  width: 150px;
  height: 40px;
  background: linear-gradient(315deg, #5cb4ec 0%, #3d96e2 100%);
  border-radius: 4px;
  margin-left: auto !important;
  margin-right: auto !important;
  font-size: 16px;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.delete-modal {
  width: 40%;
  top: 50%;
  transform: translateY(-50%);
  margin-top: 0 !important;
  .el-dialog__body {
    text-align: center;
    border-top: none;
    .content {
      padding-bottom: 10px !important;
    }
  }
}
.pb-12 .epidemicDeliverTip {
  height: 32px;
  font-size: 14px;

  font-weight: 500;
  color: #f44545;
  line-height: 32px;
  padding: 0;
  margin: 0;
  padding-left: 23px;
  margin: -16px 0 24px 24px;
  background: url(~@/assets/images/icon_deliver_tip.png) left center no-repeat;
  background-size: 16px 16px;
}
</style>

<style lang="less">
.address-tips-modal {
  margin-top: 20px !important;
  max-height: 260px;
  min-height: 50px;
  & > span {
    margin-right: 8px;
  }
  & > span::after {
    content: "、";
  }
  & > span:last-child::after {
    content: "";
  }
}
.freightDialog2 {
  width: 580px;
}
.freightDialog2 .el-dialog__title {
  font-size: 18px;
  color: #333;
  line-height: 25px;
  font-weight: bold;
}
.freightDialog2 .el-dialog__body {
  border-top: none;
  padding: 7px 24px 24px;
  border: solid 1px #e5e5e5;
  color: #666;
  line-height: 26px;
  min-height: 40px;
  font-size: 16px;
  font-weight: 400;
  color: #111111;
}
</style>
